import React, { useContext, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import { validateInput, validateDefault } from "modules/utilities/Validation";
import { useChatDuplicateList, useCustomer, useSetUserProfile } from "./store";
import { OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import EditProfile from "assets/svgs/edit_profile";
import useAssignedOrders from "modules/customerlist/store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { isEmpty } from "lodash";
import { CustomerProps } from "./ShowCustomer";

function EditInformationModal() {
  const searchParams = new URLSearchParams(location.search);
  const pageData = searchParams.get("pageNumber");
  const [show, setShow] = useState(false);
  const { fetchAssignedOrderData } = useAssignedOrders();
  const { fetchChatDuplicateList, chatDuplicateListData } = useChatDuplicateList();
  const { setUserProfileEdits, isLoading, isError, errorMessage } = useSetUserProfile();
  const { customerInfo, customer } = useContext(CustomerProps);

  const { setToaster } = useToast();

  const {
    first_name,
    phone_number,
    chat_phone_number,
    alternate_phone,
    email,
    alternate_email,
    shopify_customer_id,
    gender,
  } = customerInfo;


  const defaultForm = {
    first_name,
    phone_number,
    chat_phone_number,
    alternate_phone,
    email,
    alternate_email,
    shopify_customer_id,
    gender,
  };


  const [formData, setFormData] = useState(defaultForm);
  const [formErrors, setFormErrors] = useState({});

  const getChatNumberWarning = () => {
    if (chatDuplicateListData.length === 1) {
      const [user] = chatDuplicateListData;
      if (user.first_name === first_name) {
        return <></>;
      } else {
        return (
          <span>
            Chat number is available in {chatDuplicateListData.length} more
            profile
          </span>
        );
      }
    }
  };
  useEffect(() => {
    !formErrors?.chat_phone_number && show &&
      fetchChatDuplicateList(formData.chat_phone_number);
  }, [formData.chat_phone_number, customer, show]);

  const [submitError, setSubmitError] = useState();

  const setForm = () => {
    setFormData(defaultForm);
    setFormErrors({});
  };

  const handleClose = () => {
    setForm();
    setShow(false);
  };

  const handleShow = () => setShow(true);

  useEffect(() => {
    setForm();
    setSubmitError("");
  }, [customerInfo]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const error = validateInput(event);
    if (name === "chat_phone_number" && !error) {
      fetchChatDuplicateList(value);
    }
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setFormErrors((prevState) => ({
      ...prevState,
      [name]: error,
    }));
  };
  const { fetchCustomerData } = useCustomer();
  const handleSubmit = (event) => {
    event.preventDefault();
    const errors = Object.values(formErrors).filter(Boolean);
    if (errors.length) {
      console.error(errors);
      setSubmitError("Please fill the details properly");
    } else {
      setSubmitError("");
      let changedDetails = {};
      for (const key in defaultForm) {
        if (formData[key] !== defaultForm[key]) {
          if (
            key === "chat_phone_number" ||
            key === "alternate_phone" ||
            key === "phone_number"
          ) {
            changedDetails[key] = `+91${formData[key]}`;
          } else {
            changedDetails[key] = formData[key];
          }
        }
      }
      !isEmpty(changedDetails) &&
        setUserProfileEdits(
          changedDetails,
          setToaster,
          fetchCustomerData,
          customer
        );
      isError && setSubmitError(errorMessage);
    }
    fetchAssignedOrderData(pageData);
    handleClose();
  };
  useEffect(() => {
    setFormErrors({ ...validateDefault(formData) });
  }, [formData]);

  return (
    <>
      <div onClick={handleShow} className="text-center">
        <OverlayTrigger
          placement="bottom"
          overlay={
            <Tooltip style={{ position: "fixed" }}>Edit Profile</Tooltip>
          }
        >
          <div>
            <span className="cursor-pointer">
              <EditProfile />
            </span>
          </div>
        </OverlayTrigger>
      </div>
      <Offcanvas
        placement="end"
        name="Edit"
        show={show}
        onHide={handleClose}
        style={{ width: "30%" }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Edit Profile</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                name="first_name"
                defaultValue={formData.first_name}
                type="text"
                className="form-control text-capitalize"
                id="name"
                placeholder="Name"
                onChange={handleInputChange}
              />
              {formErrors.first_name && (
                <label className="text-danger fw-bold">
                  {formErrors.first_name}
                </label>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="gender">Gender</label>
              <select
                id="gender"
                name="gender"
                className="form-control"
                onChange={handleInputChange}
                value={formData.gender}
              >
                <option value="M">Male</option>
                <option value="F">Female</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="phone-number">Phone Number</label>
              <input
                name="phone_number"
                value={formData.phone_number?.replace("+91", "")}
                type="text"
                className="form-control"
                id="phone-number"
                placeholder="Phone Number"
                onChange={handleInputChange}
              />
              {formErrors.phone_number && (
                <label className="text-danger fw-bold">
                  {formErrors.phone_number}
                </label>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="chat-phone-number">Chat Phone Number</label>
              <input
                name="chat_phone_number"
                value={formData.chat_phone_number?.replace("+91", "")}
                type="text"
                className="form-control"
                id="chat-phone-number"
                placeholder="Chat Phone Number"
                onChange={handleInputChange}
              />
              {formErrors.chat_phone_number && (
                <label className="text-danger fw-bold">
                  {formErrors.chat_phone_number}
                </label>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="alternate-phone-number">
                Alternate Phone Number
              </label>
              <input
                name="alternate_phone"
                value={formData.alternate_phone?.replace("+91", "")}
                type="text"
                className="form-control"
                id="alternate-phone-number"
                placeholder="Alternate Phone Number"
                onChange={handleInputChange}
              />
              {formErrors.alternate_phone && (
                <label className="text-danger fw-bold">
                  {formErrors.alternate_phone}
                </label>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                name="email"
                value={formData.email}
                type="email"
                className="form-control"
                id="email"
                placeholder="Customer Email"
                onChange={handleInputChange}
              />
              {formErrors.email && (
                <label className="text-danger fw-bold">
                  {formErrors.email}
                </label>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="alternate-email">Alternate Email</label>
              <input
                name="alternate_email"
                value={formData.alternate_email}
                type="email"
                className="form-control"
                id="alternate-email"
                placeholder="Alternate Email"
                onChange={handleInputChange}
              />
              {formErrors.alternate_email && (
                <label className="text-danger fw-bold">
                  {formErrors.alternate_email}
                </label>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="shopify_customer_id">Customer ID</label>
              <input
                disabled
                value={formData.shopify_customer_id}
                type="text"
                className="form-control"
                id="shopify_customer_id"
                placeholder="Customer ID"
              />
              {formErrors.shopify_customer_id && (
                <label className="text-danger fw-bold">
                  {formErrors.shopify_customer_id}
                </label>
              )}
            </div>
            <div className="d-flex flex-column gap-4 mt-4 align-items-center">
              {chatDuplicateListData && chatDuplicateListData.length ? (
                <label className="text-warning">{getChatNumberWarning()}</label>
              ) : (
                <></>
              )}
              <Button
                type="submit"
                className="d-flex align-items-center gap-2"
                disabled={
                  isLoading ||
                  submitError ||
                  Object.values(formErrors).filter(Boolean).length !== 0
                }
              >
                Submit
              </Button>
              <label className="text-danger fw-bold">{submitError}</label>
            </div>
          </form>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default EditInformationModal;
